<template>
<div class="chapter">
<div class="inner_page">
<div id="battle_honours">
<a id="page_xv">
<p class="chap-title paracenter" style="margin-top:2em;"><span class="small">BATTLE HONOURS</span></p>
<p class="paracenter"><img alt="image" src="images/forward-1.jpg" style="max-width:100%"/></p>
<p class="paracenter" style="margin-top:6em;">Burma, 1885–87</p>
<p class="paracenter">Helles</p>
<p class="paracenter">Krithia</p>
<p class="paracenter">Suvla</p>
<p class="paracenter">Sari Bair</p>
<p class="paracenter">Gallipoli 1915</p>
<p class="paracenter">Suez Canal</p>
<p class="paracenter">Egypt 1915–16</p>
<p class="paracenter">Khan Baghdadi</p>
<p class="paracenter">Mesopotamia, 1916–18</p>
<p class="paracenter">Persia, 1918</p>
<p class="paracenter">N. W. Frontier, India, 1915</p>
<p class="paracenter">Afghanistan, 1919</p>
<p class="paracenter">Coriano</p>
<p class="paracenter">Santarcangelo</p>
<p class="paracenter">Monte Chicco</p>
<p class="paracenter">Lamone Crossing</p>
<p class="paracenter">Senio Floodbank</p>
<p class="paracenter">Medicina</p>
<p class="paracenter">Gaiana Crossing</p>
<p class="paracenter">Italy, 1944–45</p>
<p class="paracenter">Shwebo</p>
<p class="paracenter">Kyaukmyaung Bridgehead</p>
<p class="paracenter">Mandalay</p>
<p class="paracenter">Fort Dufferin</p>
<p class="paracenter">Maymyo</p>
</a><a id="page_xvi">
<p class="paracenter">Rangoon Road</p>
<p class="paracenter">Toungoo</p>
<p class="paracenter">Sittang, 1945</p>
<p class="paracenter">Chindits, 1944</p>
<p class="paracenter">Burma, 1944–45</p>
<p class="paranoindent1" style="margin-top:1em;">The Battle Honours awarded previous to <em>Burma</em>, <em>1885–87</em>, viz: <em>Arracan</em>, <em>Assam</em> and <em>Ava</em> do not appear to have been carried forward in the Army List.</p>
</a></div><a id="page_xvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_battle_honours.vue?a6a055b0